'use strict';

// import $ from 'jquery';

global.jQuery = $;


export default class Email {
  constructor() {

    const $emailBtn = $('.js-email');
    if($emailBtn.length){
      let eventTitle = $('.js-event-detail-title').text().trim();
      let eventDescription = $('.js-event-detail-description').text().trim();

      let emailSubject = "consultaustralia.com.au - " + eventTitle;
      let lineBreak = "%0D%0A%0D%0A";
      let eventUrl = window.location.href;
      let emailBodyGreeting = "Hi," + lineBreak  + eventTitle +  lineBreak + "I found this event from consultaustralia.com.au that you might be interested in:" + lineBreak + eventDescription;
      let emailBody =  emailBodyGreeting + lineBreak + eventUrl;

      $emailBtn.on('click', function(e){
        e.preventDefault();
        window.location.href = "mailto:?subject=" + emailSubject + "&body=" + emailBody;
      })

    }
  }
}
